export interface BreakProps {
    customClass?: string;
}

export const Break: React.FC<BreakProps> = ({ customClass = "" }) => (
    <hr className={customClass} />
);
